module.exports = __webpack_public_path__ + "fonts/iconfont.92ef8269.woff2";